import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import BorrowerBinder from "./BorrowerBinder";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public, print-only render of the BORROWER COPY (borrower-eyes-only documents).
// Used by the Document Center to generate/print the borrower's package. Chrome
// prints this via page.pdf; borrowerView hides all lender/counterparty pages.
export default function BorrowerCopyPrint() {
  const { appId } = useParams();
  const t = new URLSearchParams(useLocation().search).get("t");
  const [app, setApp] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const ep = t
          ? `${API}/borrower/applications/${appId}/public?t=${encodeURIComponent(t)}`
          : `${API}/borrower/applications/${appId}`;
        const r = await axios.get(ep);
        if (alive) setApp(r.data.application);
      } catch { /* ignore */ }
    })();
    return () => { alive = false; };
  }, [appId, t]);

  if (!app) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center" data-testid="borrower-copy-loading">
        <Loader2 className="animate-spin text-[#0B4636]" />
      </div>
    );
  }

  return (
    <BorrowerBinder
      binder={app.binder}
      signatures={app.signatures || []}
      titleAccepted={!!app.title_accepted}
      updatedAt={app.updated_at}
      borrowerView
    />
  );
}
